import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from '../reducers'
import { persistStore, persistReducer } from 'redux-persist'
import { CookieStorage } from 'redux-persist-cookie-storage'
import Cookies from 'cookies-js'
import thunk from 'redux-thunk'
import initialState from '../reducers/initialState'

const enhancers = []
const middleware = [thunk]

const persistConfig = {
    key: 'root',
    blacklist: ['editorState'],
    storage: new CookieStorage(Cookies, {
        expiration: {
            'default': 12*60*60
          }
    })
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

if (process.env.NODE_ENV !== 'production') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension())
    }
}

const composedEnhancers = compose(
    applyMiddleware(...middleware),
    ...enhancers,
)

export default () => {
    const store = createStore(persistedReducer, initialState, composedEnhancers)
    return {
        store,
        persistor: persistStore(store),
    }
}
